module.exports = __webpack_public_path__ + "img/ExhibitSpecialTitle.2927f369.png";